<template>
  <div class="home">
    <div class="good-bigimage-box" v-bind:class="{ activegoodimage: activegoodimage }" v-on:click=onCloseImageClick>
      <div class="good-bigimage">
        <img class="good-bigimage-img" :src="activeImage">
        <div class="good-bigimage-title">{{activeImageTitle}}</div>
      </div>
    </div>
    <div class="container">
      <swiper :options="swiperOption" class="swiper" ref="swiper"  v-if=promos>
        <swiper-slide v-for="(promo) in promos" class="slide" >
          <img :src="promo" >
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination" v-if=promosCount></div>

        <div class="swiper-buttons swiper-button-prev swiper-button-white" slot="button-prev" v-on:click=onPrevClick() v-if=promosCount></div>
        <div class="swiper-buttons swiper-button-next swiper-button-white" slot="button-next" v-on:click=onNextClick() v-if=promosCount></div>

      </swiper>

      <div class="album-pretitle"></div>
      <div v-for="(album) in albumsAndGoods" :key="album.id">
        <div :id=album.titleEn class="anchor"></div>
        <div class="album-title">{{album.title}}</div>
        <div class="goods"> 
          <div class="good" v-for="(good) in album.goods" :key="good.id">
            <div class="good-top">
              <div class="good-image">
                <img :src="good.thumb_photo" :alt="good.title" v-on:click=onOpenImageClick(good.thumb_photo,good.photo,good.title)>
              </div>
              <div class="good-title-description-price">
                <div class="good-top-mobile">
                  <div class="good-title">{{good.title}}</div>
                  <div class="good-description">{{good.description}}</div>
                </div>
                <div class="good-bottom-mobile">
                  <div class="good-price-mobile">{{good.price}} ₽</div>
                  <div class="good-cart-mobile noselect" v-on:click=onAddToCartClick(good.id,true) v-bind:class="{ 'good-cart-mobile-active': !good.cart }">В корзину</div>
                  <div class="good-cart-mobile-change noselect" v-bind:class="{ 'good-cart-mobile-change-active': good.cart }" >
                    <div class="good-cart-mobile-minus" v-on:click=onAddToCartClick(good.id,false)>-</div>
                    <div class="good-cart-mobile-count">{{good.cart}}</div>
                    <div class="good-cart-mobile-plus" v-on:click=onAddToCartClick(good.id,true)>+</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="good-bottom">
              <div class="good-price">{{good.price}} ₽</div>
              <div class="good-cart noselect" v-on:click=onAddToCartClick(good.id,true) v-bind:class="{ 'good-cart-active': !good.cart }">В корзину</div>
              <div class="good-cart-change noselect" v-bind:class="{ 'good-cart-change-active': good.cart }" >
                <div class="good-cart-minus" v-on:click=onAddToCartClick(good.id,false)>-</div>
                <div class="good-cart-count">{{good.cart}}</div>
                <div class="good-cart-plus" v-on:click=onAddToCartClick(good.id,true)>+</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-nav">
      <div class="container">
        <router-link to="/">Главная</router-link>
        <router-link to="/delivery">Доставка</router-link>
        <router-link to="/about">О нас</router-link>
        <router-link to="/about#contacts">Контакты</router-link>
        <div class="bottom-nav-push"></div>
        <a class="bottom-nav-social" href="https://vk.com/idakodelivery" target="_blank" rel="noopener"><img :src="vk"></a>
        <a class="bottom-nav-social bottom-nav-social-ig" href="https://instagram.com/idako_delivery_chita" target="_blank" rel="noopener"><img :src="ig"></a>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import vk from '@/assets/vk.svg'
import ig from '@/assets/ig.svg'

export default {
  name: 'home',
  data() {
    return {
      vk: vk,
      ig: ig,
      activegoodimage: false,
      activeImage: '',
      activeImageTitle: '',
      swiperOption: {
        autoHeight: true,
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-prev',
          prevEl: '.swiper-next'
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide,
  },

  computed: {
    albumsAndGoods () {
      return this.$store.getters.getAlbumsAndGoods
    },
    promos () {
      return this.$store.getters.getPromos
    },
    promosCount () {
      return this.$store.getters.getPromosCount
    }
    
  },
  methods: {
    onPrevClick(){
      this.$refs.swiper.swiper.slidePrev()
    },
    onNextClick(){
      this.$refs.swiper.swiper.slideNext()
    },
    onAddToCartClick(id,type){
      this.$store.dispatch('addToCart',{id, type})
    },
    onOpenImageClick(imgThumb, photo, title){
      var img = ''
      this.activegoodimage = true;
      document.body.classList.add("overflow-hidden");
      if (window.screen.width < 601 || !photo.hasOwnProperty("photo_1280")) {
        img = imgThumb
      }else{
        img = photo.photo_1280
      }
      this.activeImage = img
      this.activeImageTitle = title
    },
    onCloseImageClick(){
      this.activegoodimage = false;
      this.activeImage = ''
      document.body.classList.remove("overflow-hidden");
    }
  }
}
</script>

<style lang="scss">

.home{
  height: 100%;
}

.swiper{
  margin: 0 10px;
  .swiper-slide {
    img{
      width: 100%;
      height: auto;
    }
  }
}

.swiper-buttons{
  opacity: 0.7;
}

.swiper-pagination-bullet-active{
  background: white;
  opacity: 0.7;
}

.anchor{
  position: absolute;
  // For scrool to top of title
  margin: -68px; 
}
.album-pretitle{
  height: 16px;
}
.album-title{
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 16px;
  padding-left: 10px;
}

.goods{
  display: flex;
  flex-wrap: wrap;
}

.good{
  margin-bottom: 16px;
  padding: 0 10px;
  width: 240px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .good-image{
    width: 220px;
    height: 220px;
    
    img{
      cursor: pointer;
      box-shadow: 0px 0px 21px -10px rgba(0,0,0,0.75);
      width: 220px;
      border-radius: 10px;
      // height: 150px;
    }
    margin-bottom: 12px;
  }
  .good-title{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 8px;
  }
  .good-description{
    margin-bottom: 12px;
    font-size: 15px;
    color: #666;
  }
  .good-bottom{
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    .good-price{
      font-size: 20px;
      font-weight: bold;
    }
    .good-cart{
      color: #D86659;
      text-align: center;
      border-radius: 8px;
      border: 1px solid #D86659;
      padding: 0 14px;
      cursor: pointer;
      font-size: 16px;
      width: 120px;
      &:hover{
        color: rgb(184, 72, 60);
        border: 1px solid rgb(184, 72, 60);
      }
      display: none;
      &.good-cart-active{
        display: block;
      }
    }
    .good-cart-change{
      display: none;
      width: 120px;
      &.good-cart-change-active{
        display: flex;
      }
      .good-cart-minus,
      .good-cart-plus{
        color: #D86659;
        text-align: center;
        border-radius: 8px;
        border: 1px solid #D86659;
        cursor: pointer;
        font-size: 20px;
        width: 40px;
      }
      .good-cart-count{
        font-size: 20px;
        width: 40px;
        text-align: center;
      }
    }
  }
  .good-bottom-mobile{
    display: none;
  }
}

.bottom-nav{
  border-top: 1px solid #ddd;
  .container{
    display: flex;
    height: 60px;
    align-items: center;
    padding: 0 10px;
    a{
      color: #777;
      margin-right: 20px;
      &:hover{
        color: #333;
      }
    }
    .bottom-nav-push{
      flex-grow: 1;
    }
    .bottom-nav-social{
      img{
        border: 1px solid #999;
        border-radius: 30px;
        padding: 2px;
        height: 30px;
        widows: 30px;
        &:hover{
          border: 1px solid #777;
        }
      }
    }
    .bottom-nav-social-ig{
      margin-right: 0;
    }
  }
}

.good-bigimage-box{
  display: none;
  position: fixed;
  top:0;
  left:0;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  z-index: 1;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &.activegoodimage{
    display: flex;
  }
  z-index: 10;
  .good-bigimage{
    height: 80%;
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .good-bigimage-img{
      max-width: 100%;
      max-height: 100%;
      margin: 0 auto;
      border-radius: 10px;
      object-fit: contain;
    }
    .good-bigimage-title{
      color: white;
      text-align: center;
      font-size: 20px;
      margin-top: 10px;
    }
  }
}

@media only screen and (max-width: 959px){
  .album-title{
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 16px;
    padding-left: 10px;
  }
  .good{
    width: 50%;
    height: auto;
    margin-bottom: 20px;
    .good-top{
      display: flex;
      flex-direction: row;
      height: 100%;
      .good-image{
        height: auto;
        flex-basis: 35%;
        margin-bottom: 0;    
        img{
          box-shadow: 0px 0px 10px -5px rgba(0,0,0,0.75);
          width: 100%;
          height: auto; // for tablet
          border-radius: 2px;
        }
      }
      .good-title-description-price{
        padding-left: 10px;
        flex-basis: 65%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .good-title{
          margin-bottom: 4px;
        }
        .good-description{
          font-size: 12px;
          margin-bottom: 4px;
        }
        .good-bottom-mobile{
          display: flex;
          justify-content: space-between;
          height: 36px;
          line-height: 36px;
          bottom: 0;
          .good-price-mobile{
            display: block;
            font-size: 14px;
            font-weight: bold;
          }
          .good-cart-mobile{
            display: block;
            color: white;
            background-color: #D86659;
            text-align: center;
            border-radius: 4px;
            width: 100px;
            cursor: pointer;
            font-size: 14px;
            &:hover{
              color: white;
              border: none;
            }
            display: none;
            &.good-cart-mobile-active{
              display: block;
            }
          }
          .good-cart-mobile-change{
            display: none;
            width: 100px;
            &.good-cart-mobile-change-active{
              display: flex;
            }
            .good-cart-mobile-minus,
            .good-cart-mobile-plus{
              color: white;
              text-align: center;
              border-radius: 8px;
              background-color: #D86659;
              cursor: pointer;
              font-size: 18px;
              width: 33px;
            }
            .good-cart-mobile-count{
              font-size: 16px;
              width: 33px;
              text-align: center;
            }
          }
        }
      }
    }
    .good-bottom{
      display: none;
    }
  }

  // .good-bigimage-box{
  //   .good-bigimage{
  //     height: 70%;
  //     width: 70%;
  //   }
  // }
  .swiper{
    margin: 0;
    .swiper-buttons{
      display: none;
    }
  }
}

@media only screen and (max-width: 600px){
  .good{
    width: 100%;
  }
  .good-bigimage-box{
  .good-bigimage{
      width: 100%;
      height: auto;
      padding: 10px;
      .good-bigimage-img{
        border-radius: 5px;
      }
    }
  }
}

@media only screen and (max-width: 500px){
  .good{
    width: 100%;
    .good-top{
      .good-image{
        flex-basis: 40%;
        img{
          width: 100%;
        }
      }
      .good-title-description-price{
        flex-basis: 60%;
      }
      .good-title-description-price{
        flex-basis: 70%;
        .good-title{
          margin-bottom: 6px;
        }
        .good-description{
          font-size: 14px;
          margin-bottom: 6px;
        }
        .good-bottom-mobile{

          .good-price-mobile{
            font-size: 16px;
          }
          .good-cart-mobile{
            font-size: 16px;
          }
        }
      }
    }
  }
  .bottom-nav{
    display: none;
  }
  .good-bigimage-box{
    .good-bigimage{
      width: 100%;
      height: auto;
      padding: 10px;
      .good-bigimage-img{
        border-radius: 5px;
      }
    }
  }
}


@media only screen and (max-width: 330px){
  .good{
    .good-top{
      .good-image{
        flex-basis: 30%;
      }
      .good-title-description-price{
        flex-basis: 70%;
      }
      .good-title-description-price{
        flex-basis: 70%;
        .good-title{
          margin-bottom: 3px;
        }
        .good-description{
          font-size: 12px;
          margin-bottom: 3px;
        }
        .good-bottom-mobile{

          .good-price-mobile{
            font-size: 14px;
          }
          .good-cart-mobile{
            font-size: 14px;
          }
        }
      }
    }
  }
}

</style>
